module.exports = __webpack_public_path__ + "img/goBack.ace7584a.svg";